module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-SemiboldItalic-c37410d3357d5afdc8cfd2e435288a1b.woff2";